import React, { FC } from 'react';
import styled from 'styled-components';
import _map from 'lodash/map';
import Modal from '@minecraft.modal';
import { SelectOption } from '../../../shared/types';

const PillValue = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  text-align: center;
  margin: 0;
`;

type Props = {
  pillValues: SelectOption[];
  pillKey: string;
  toggleModal: () => void;
};

const FilterBasicBreadboxSeeMoreValuesModal: FC<Props> = ({ pillKey, pillValues, toggleModal }) => (
  <Modal
    data-testid={`${pillKey}-tt-modal`}
    data-qa-id={`${pillKey}-tt-modal`}
    isOpen
    isFooterHidden
    modalSize="small"
    handleToggleClick={toggleModal}
  >
    <>
      {_map(pillValues, (pillValue) => (
        <PillValue key={pillValue?.value}>{pillValue.label}</PillValue>
      ))}
    </>
  </Modal>
);

export default FilterBasicBreadboxSeeMoreValuesModal;
